module.exports = __webpack_public_path__ + "static/img/video_categories.92e419e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/page__hero__img/video_categories.png
// module id = 562
// module chunks = 1